import "./assets/css/theme.css";
import "bootstrap/dist/js/bootstrap.js";

import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./page/Home";
import Login from "./page/auth/Login";
import Logout from "./page/auth/Logout";
import OrderList from "./page/treadeBook/OrderList";
import PlaceOrder from "./page/treadeBook/PlaceOrder";
import AlgoList from "./page/algo/AlgoList";

import LogViewer from "./page/logs/LogViewer";
import ApiErrorLogViewer from "./page/logs/ApiErrorLogViewer";
import UserManagement from "./page/admin/UserManagement";
import Settings from "./page/admin/Settings";
import AdminData from "./page/admin/AdminData";
import PageWraper from "./compontents/comman/PageWraper";
import ProtectedRoute from "./compontents/auth/ProtectedRoute";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/logout" element={<Logout />} />

        {/* Protected Routes */}
        <Route element={<ProtectedRoute />}>
          <Route path="/" element={<PageWraper><Home /></PageWraper>} />
        </Route>

        <Route element={<ProtectedRoute requiredPermission="Trade Book" />}>
          <Route path="/tradebook" element={<PageWraper><OrderList /></PageWraper>} />
          <Route path="/tradebook/add" element={<PageWraper><PlaceOrder /></PageWraper>} />
        </Route>

        <Route element={<ProtectedRoute requiredPermission="Algo" />}>
          <Route path="/algo" element={<PageWraper><AlgoList /></PageWraper>} />
        </Route>

        <Route element={<ProtectedRoute requiredPermission="Logs" />}>
          <Route path="/logs" element={<PageWraper><LogViewer /></PageWraper>} />
          <Route path="/api-logs" element={<PageWraper><ApiErrorLogViewer /></PageWraper>} />
        </Route>

        <Route element={<ProtectedRoute requireAdmin={true} />}>
          <Route path="/admin/users" element={<PageWraper><UserManagement /></PageWraper>} />
          <Route path="/admin/settings" element={<PageWraper><Settings /></PageWraper>} />
          <Route path="/admin/data" element={<PageWraper><AdminData /></PageWraper>} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
